import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';
import { RESOURCE_CATEGORIES } from '../constants/resourceCategories';

export const MERCH_RESOURCE_CATEGORY = {
  id: 'merch',
  label: 'Merch',
  iconName: 'shirt-outline',
};

function mergeCategoryCatalog(snapshot) {
  const storedCategories = snapshot.docs
    .map((categoryDoc) => ({
      id: categoryDoc.id,
      label: String(categoryDoc.data().label || '').trim(),
    }))
    .filter((category) => category.id && category.label);
  const categories = [...RESOURCE_CATEGORIES, MERCH_RESOURCE_CATEGORY];
  const knownIds = new Set(categories.map((category) => category.id));

  storedCategories.forEach((category) => {
    if (knownIds.has(category.id)) return;
    knownIds.add(category.id);
    categories.push(category);
  });

  return categories;
}

export async function fetchResourceCategoryCatalog(db) {
  return mergeCategoryCatalog(await getDocs(collection(db, 'resource_categories')));
}

export function subscribeResourceCategoryCatalog(db, onChange, onError) {
  return onSnapshot(
    collection(db, 'resource_categories'),
    (snapshot) => onChange(mergeCategoryCatalog(snapshot)),
    onError,
  );
}

export function resourceCategoryIdFromLabel(label) {
  return String(label || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 48);
}

export async function saveResourceCategory(db, label, createdBy = null) {
  const normalizedLabel = String(label || '').trim().replace(/\s+/g, ' ');
  const id = resourceCategoryIdFromLabel(normalizedLabel);
  if (!id) throw new Error('Enter a valid resource category name.');

  const knownCategory = [...RESOURCE_CATEGORIES, MERCH_RESOURCE_CATEGORY]
    .find((category) => category.id === id);
  if (knownCategory) return knownCategory;

  const categoryRef = doc(db, 'resource_categories', id);
  const snapshot = await getDoc(categoryRef);
  if (!snapshot.exists()) {
    await setDoc(categoryRef, {
      label: normalizedLabel,
      createdAt: serverTimestamp(),
      createdBy: createdBy || null,
    });
  }

  return { id, label: snapshot.exists() ? snapshot.data().label : normalizedLabel };
}
